function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { jsx } from "panel";
import { FullWidthReportEl } from "common/widgets/fullwidth-report";
import { DownloadWrapperEl } from "common/components/download-wrapper";
import { UpsellModalEl } from "common/widgets/upsell-modal";
import { LoadingResource, ReportEditorActivePanel } from "common/report-editor/types";
import { DownloadFormat } from "common/report/util/report-download";
import { ToggleEl } from "common/components/toggle";
import { ChartCustomizationPanelEl } from "common/query-builder/chart-customization/panel";
import { QueryReason } from "common/report/util/query-tracking/types";
import { ToggleTheme } from "common/components/toggle/types";
import { ChartRootEl } from "common/charts/root";
export function template() {
  var _this$state$reportMan, _this$state$reportMan2, _this$state$reportMan3, _this$state$reportMan4, _this$state$editedBoo2;
  const ReportQueryBuilderEl = (_this$state$reportMan = this.state.reportManager) === null || _this$state$reportMan === void 0 ? void 0 : _this$state$reportMan.queryBuilderEl;
  const ReportVisualizationEl = (_this$state$reportMan2 = this.state.reportManager) === null || _this$state$reportMan2 === void 0 ? void 0 : _this$state$reportMan2.visualizationEl;
  const ReportHeaderEl = (_this$state$reportMan3 = this.state.reportManager) === null || _this$state$reportMan3 === void 0 ? void 0 : _this$state$reportMan3.reportHeaderEl;
  const visualizationEl = ReportVisualizationEl && /* @__PURE__ */ jsx(ReportVisualizationEl, { attrs: _objectSpread(_objectSpread({}, this.visualizationAttrs()), {}, {
    elref: "reportVisualization"
  }), props: this.visualizationProps(), hook: {
    insert: this.helpers.vizInserted
  }, on: this.visualizationEventHandlers });
  if (this.isDownloadMode()) {
    var _this$state$editedBoo;
    return ReportVisualizationEl && /* @__PURE__ */ jsx(ChartRootEl, { params: {
      bookmarkParams: (_this$state$editedBoo = this.state.editedBookmark) === null || _this$state$editedBoo === void 0 ? void 0 : _this$state$editedBoo.params
    } }, /* @__PURE__ */ jsx(DownloadWrapperEl, { sel: ".download-wrapper-el", class: {
      "inherit-size": true
    }, attrs: {
      meta: this.getReportMeta(),
      mode: this.getDownloadMode(),
      elref: "downloadWrapper"
    } }, visualizationEl));
  }
  const upsell = (_this$state$reportMan4 = this.state.reportManager) === null || _this$state$reportMan4 === void 0 ? void 0 : _this$state$reportMan4.getReportUpsell(this.currentProjectContext);
  const isQueryBuilderReady = ReportQueryBuilderEl && this.state.renderStage >= 3 && !this.state.loading[LoadingResource.ApiResources];
  return /* @__PURE__ */ jsx("div", { sel: ".mp-report-editor", class: {
    "inherit-size": true
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(ChartRootEl, { params: {
    bookmarkParams: (_this$state$editedBoo2 = this.state.editedBookmark) === null || _this$state$editedBoo2 === void 0 ? void 0 : _this$state$editedBoo2.params,
    onBookmarkUpdate: (_ref) => {
      let {
        params,
        requery
      } = _ref;
      return this.handleBookmarkUpdate({
        params,
        requery
      });
    }
  }, "data-sentry-element": "ChartRootEl", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(FullWidthReportEl, { sel: ".fullwidth-report-el", class: {
    "inherit-size": true
  }, params: {
    exportSegmentationLimit: this.state.maxExportCsvLimit,
    isSegmentationLimitHit: this.state.hasReportHitUxSegmentationLimit,
    reportSamplingFactor: this.state.reportSamplingFactor,
    segmentationLimit: this.state.uxSegmentationLimit,
    reportHeader: ReportHeaderEl && this.state.renderStage >= 1 ? /* @__PURE__ */ jsx(ReportHeaderEl, { attrs: {
      elref: "reportHeader"
    }, params: this.reportHeaderParams(), props: this.reportHeaderProps(), on: this.reportHeaderEventHandlers, hook: {
      insert: this.helpers.headerInserted
    } }) : /* @__PURE__ */ jsx("div", { sel: ".report-header-loading" }, /* @__PURE__ */ jsx("div", { sel: ".mp-skeleton-header" })),
    panelHeader: isQueryBuilderReady && /* @__PURE__ */ jsx("div", { sel: ".query-panel-toggle" }, /* @__PURE__ */ jsx(ToggleEl, { attrs: {
      elref: "queryPanelToggle",
      theme: ToggleTheme.TabBarBorderless,
      selected: this.state.activePanel
    }, params: {
      options: [{
        label: (_ref2) => {
          let {
            t
          } = _ref2;
          return t("query-builder.report-query-tab");
        },
        value: ReportEditorActivePanel.QueryBuilder
      }, {
        label: (_ref3) => {
          let {
            t
          } = _ref3;
          return t("query-builder.chart-customization-tab");
        },
        value: ReportEditorActivePanel.ChartCustomization
      }]
    }, on: {
      select: (ev) => this.update({
        activePanel: ev.detail.selected
      })
    } })),
    queryBuilder: isQueryBuilderReady ? /* @__PURE__ */ jsx("div", null, this.state.activePanel === ReportEditorActivePanel.QueryBuilder ? /* @__PURE__ */ jsx(ReportQueryBuilderEl, { params: this.queryBuilderParams(), on: this.queryBuilderEventHandlers, hook: {
      insert: this.helpers.qbInserted
    } }) : /* @__PURE__ */ jsx(ChartCustomizationPanelEl, { bookmarkType: this.state.editedBookmark.type, bookmarkParams: this.state.editedBookmark.params, onUpdate: (updateType, update, diff, old) => this.handleChartCustomizationUpdate(updateType, update, diff, old), onUpdateTheme: (params) => {
      this.handleBookmarkUpdate({
        params,
        queryReason: QueryReason.QbOtherUpdate,
        requery: false,
        hasChangedChartType: false
      });
    } })) : /* @__PURE__ */ jsx("div", { sel: ".qb-loading", attrs: {
      elref: "loadingQB"
    } }, /* @__PURE__ */ jsx("div", { sel: ".mp-skeleton-header" }), /* @__PURE__ */ jsx("div", { sel: ".mp-skeleton-large" }), /* @__PURE__ */ jsx("div", { sel: ".mp-skeleton-large" }), /* @__PURE__ */ jsx("div", { sel: ".mp-skeleton-large" })),
    report: ReportVisualizationEl && this.state.renderStage >= 2 && !this.state.loading[LoadingResource.ApiResources] && /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".results", attrs: {
      slot: "report"
    } }, visualizationEl))
  }, on: {
    exportcsvclicked: (_) => this.handleExport(DownloadFormat.CSV)
  }, "data-sentry-element": "FullWidthReportEl", "data-sentry-source-file": "template.tsx" })), upsell && /* @__PURE__ */ jsx(UpsellModalEl, { attrs: _objectSpread(_objectSpread({}, upsell.attrs), {}, {
    elref: "upsellModal"
  }), props: upsell.props }));
}
